import script from "./BroadcastCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastCampaigns.vue?vue&type=style&index=0&id=a51dd446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a51dd446"]])

export default __exports__